const getBaseOrder = (targetItem) => {
    if (!targetItem) return 0

    if (typeof targetItem._original_order === 'undefined') {
        const currentOrder = parseFloat(targetItem.order)
        targetItem._original_order = Number.isNaN(currentOrder) ? 0 : currentOrder
    }

    return parseFloat(targetItem._original_order)
}

const getOrderParentId = (targetItem, itemsById) => {
    if (!targetItem) return false

    if (targetItem.parent_id && itemsById[targetItem.parent_id]) {
        return targetItem.parent_id
    }

    if (targetItem.conditions && targetItem.conditions.values) {
        for (const parentIdFromCondition in targetItem.conditions.values) {
            if (itemsById[parentIdFromCondition]) {
                return parentIdFromCondition
            }
        }
    }

    return false
}

const buildHierarchicalOrderedItems = (itemsMap) => {
    const allItems = Object.values(itemsMap || {})
    if (allItems.length === 0) {
        return itemsMap || {}
    }

    const itemsById = {}
    allItems.forEach((candidate) => {
        itemsById[candidate.item_id] = candidate
    })

    const childrenByParent = {}
    const rootItems = []

    allItems.forEach((candidate) => {
        const parentId = getOrderParentId(candidate, itemsById)

        if (parentId && parentId !== candidate.item_id) {
            if (!childrenByParent[parentId]) {
                childrenByParent[parentId] = []
            }
            childrenByParent[parentId].push(candidate)
        } else {
            rootItems.push(candidate)
        }
    })

    const compareByBaseOrder = (leftItem, rightItem) => getBaseOrder(leftItem) - getBaseOrder(rightItem)

    rootItems.sort(compareByBaseOrder)
    Object.keys(childrenByParent).forEach((parentId) => {
        childrenByParent[parentId].sort(compareByBaseOrder)
    })

    const visitedItems = {}
    const orderedItems = []

    const walk = (candidate) => {
        if (!candidate || visitedItems[candidate.item_id]) {
            return
        }

        visitedItems[candidate.item_id] = true
        orderedItems.push(candidate)

        const children = childrenByParent[candidate.item_id] || []
        children.forEach(walk)
    }

    rootItems.forEach(walk)

    allItems
        .filter((candidate) => !visitedItems[candidate.item_id])
        .sort(compareByBaseOrder)
        .forEach(walk)

    const orderedItemsMap = {}
    orderedItems.forEach((candidate, index) => {
        candidate.order = index + 1
        orderedItemsMap[candidate.item_id] = candidate
    })

    return orderedItemsMap
}

const getVisibleDescendants = (itemsMap, rootItemId) => {
    const items = Object.values(itemsMap || {})

    const collect = (parentId) => {
        const children = items
            .filter((item) => item.parent_id === parentId && item.is_visible)
            .sort((leftItem, rightItem) => {
                const orderA = parseFloat(leftItem.order) || 0
                const orderB = parseFloat(rightItem.order) || 0
                return orderA - orderB
            })

        const descendants = []
        children.forEach((child) => {
            descendants.push(child)
            descendants.push(...collect(child.item_id))
        })
        return descendants
    }

    return collect(rootItemId)
}

const getItemsBySection = (itemsMap, section) => {
    let newSectionFound = false
    let startLooking = false
    const resultItems = {}
    let items = itemsMap ? Object.values({ ...itemsMap }) : []

    items = items.filter((obj) => {
        return !obj.parent_id
    })

    items
        .sort((l, r) => l.order - r.order)
        .forEach((item) => {
            if (item.type != 8 && startLooking && !newSectionFound) {
                resultItems[item.item_id] = item
            } else {
                if (!startLooking && item.item_id == section) {
                    startLooking = true
                } else if (startLooking) {
                    newSectionFound = true
                    startLooking = false
                }
            }
        })

    return resultItems
}

export { getBaseOrder, getOrderParentId, buildHierarchicalOrderedItems, getVisibleDescendants, getItemsBySection }
